import React from 'react'
import { Link } from 'react-router-dom'

function Futuro2() {
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/semiverticals" className="block py-1 pl-4 hover:underline mt-6">Semi-Verticals-</Link>
           <span className="block py-1 pl-4 mt-6">FUTURO 2</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/FUTURO-upper.jpg" alt="Daisy" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">FUTURO 2</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">The most complete and flexible self-service solution for food retail.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">FUTURO 2 semi-verticals, the specialist solution for self-service. The line is available in refrigerated models, with different heights and widths, to better adapt to store space. Maximum product display capacity with the best visibility for packaged goods.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <p className="text-xl lg:text-2xl opacity-90">Packaged Cod Fish, Meat and Sushi <span className=' text-blue-400'>-1… +5 °C</span> (3M1)</p>

         <p className="text-xl lg:text-2xl opacity-90">Beverages, Packaged Charcuterie and Pastry<span className=' text-blue-400'>-1… +7 °C</span> (3M2)</p>
       <p className="text-xl lg:text-2xl opacity-90">Packaged Hot Food<span className='text-red-600'> +65 °C</span> </p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3">CO2 | Glycol |  R290</p>
         </div>

         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/futuro2case.gif" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Three models, three widths, three heights</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>FUTURO 2 semi-verticals are available in 3 heights, 120 cm, 130 cm and 160 cm - models with up to 4 display levels for maximum capacity. Models are 80 cm (SLIM), 97 cm (STD) and 110 cm (XL) wide to easily adjust to all the shapes, sizes and needs of your shop.</div>
</div>

                
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Less investment, faster installation</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>New FUTURO 2 TWIN refrigerated semivertical. The benefits of the gondola layout adding up to greater energy savings, easier installation and maintenance, lower investment, faster return. Among other things, thanks to the single-channel refrigeration system and shared evaporator.</div>
</div>
 {/* ✅ Image Wrapper */}
 <div className="w-full md:w-1/2">
                 <img src="/images/futuro2case1.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
    {/* case 3 */}
    <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/futuro2case2.jpg" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl lg:text-4xl">Takeaway and hot food always warm and ready to go</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>On-demand heated models for self-service roast chicken, pasta, soups, noodles... the FUTURO 2 heated semi-verticals make your best hot products visible and always at your customers' fingertips.</div>
</div>
             </div>

              {/* case 4 */}
    <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl lg:text-4xl">Self-service of refrigerated products with greater energy savings!</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Refrigerated models with sliding front doors option, allowing energy savings of up to 50% without compromising the visibility that products deserve.
    Doors designed for easy and ergonomic opening, providing convenience in everyday use. Handles with nanocoat® treatment (optional), which guarantees greater durability and hygiene.</div>
</div>
  {/* ✅ Image Wrapper */}
  <div className="w-full md:w-1/2">
                 <img src="/images/futuro2case3.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
         </div>
    
    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center">
  {[
    {
      img: "images/futuro2card.jpg",
      text: "Available in models with integrated unit (plug-in) or for remote condensing unit.",
    },
    {
      img: "images/futuro2card1.gif",
      text: "Models with panoramic glass or stainless-steel backs.",
    },
    {
      img: "images/futuro2card2.jpg",
      text: "Glass shelves or tilting steel shelves with price holders options.",
    },
    {
      img: "images/futuro2card3.jpg",
      text: "Internal components easy to remove and clean.",
    },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6 md:mt-20">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>


     </div>
    
  
        </div>
      )
    }

export default Futuro2



